import { render, staticRenderFns } from "./SkeletonPublicidades.vue?vue&type=template&id=ebcf252c&scoped=true"
import script from "./SkeletonPublicidades.vue?vue&type=script&lang=js"
export * from "./SkeletonPublicidades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebcf252c",
  null
  
)

export default component.exports